import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var Common = namespace('common');

var AnounceDetail = function (_super) {
  __extends(AnounceDetail, _super);

  function AnounceDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.detailPending = false;
    _this.detailData = {};
    return _this;
  }

  AnounceDetail.prototype.initDetail = function () {
    var id = Number(this.$route.query.id);

    if (!id) {
      this.$message.error(this.t('地址需有合法的公告id'));
    }

    this.querySmMessageDetail({
      id: id
    });
  };

  AnounceDetail.prototype.querySmMessageDetail = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.announce.querySmMessageDetail(param)];

          case 1:
            data = _a.sent().data;
            this.detailData = data;
            this.setSmMessageAckBulk({
              id_list: [data.id]
            });
            return [2];
        }
      });
    });
  };

  AnounceDetail.prototype.setSmMessageAckBulk = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.announce.setSmMessageAckBulk(param, {
              showError: false,
              loading: false
            })];

          case 1:
            data = _a.sent().data;
            this.$store.commit('user/SET_UNREAD_TOTAL', data);
            return [2];
        }
      });
    });
  };

  AnounceDetail.prototype.created = function () {
    this.initDetail();
  };

  AnounceDetail = __decorate([Component], AnounceDetail);
  return AnounceDetail;
}(Vue);

export default AnounceDetail;